import { createFileRoute, redirect } from '@tanstack/react-router';

import {
  OverviewPage,
  overviewSearchSchema,
} from '@/features/workspace-overview';

export const Route = createFileRoute('/workspaces/$workspaceId/')({
  // Read only to send old links on: the Overview is no longer narrowed by
  // text or label (spec 152 US6). An address that asks for a narrowing opens
  // the Tasks page with the same one, so bookmarks keep working.
  validateSearch: overviewSearchSchema,
  beforeLoad: ({ params, search }) => {
    if (search.q === undefined && search.labels === undefined) return;
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/workspaces/$workspaceId/tasks',
      params,
      search: { q: search.q, labels: search.labels },
    });
  },
  component: OverviewRoute,
});

export function OverviewRoute() {
  const { workspaceId } = Route.useParams();
  return <OverviewPage workspaceId={workspaceId} />;
}
